import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import "./styles/ProjectDetail.scss";
import projectData from "./data/projectsData.json";

const ProjectDetail = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [project, setProject] = useState(null);

  useEffect(() => {
    const foundProject = projectData.projects.find(
      (project) => project.id === parseInt(id)
    );
    setProject(foundProject);
  }, [id]);

  if (!project) {
    return <p>Project not found</p>;
  }

  return (
    <main className="project-pageee">
      <main className="project-detail">
        <button className="back-button" onClick={() => navigate(-1)}>
          ← Back
        </button>
        <h2>{project.title}</h2>
        <section className="project-metadata">
          <p><strong>Author:</strong> {project.author}</p>
          <p><strong>Date:</strong> {project.date}</p>
        </section>
        <section className="project-video">
          <video controls>
            <source src={project.videoUrl} type="video/mp4" />
            Your browser does not support the video tag.
          </video>
        </section>
        <p className="project-description">{project.description}</p>
      </main>
    </main>
  );
};

export default ProjectDetail;
